var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list_board" }, [
    _c(
      "ul",
      { staticClass: "list_gallery", attrs: { id: "more-article-list" } },
      [
        _vm._l(_vm.articles, function (article) {
          return [
            _vm.isRestricted(article)
              ? _c(
                  "restricted-album-article-item",
                  _vm._b({}, "restricted-album-article-item", article, false)
                )
              : _c(
                  "album-article-item",
                  _vm._b({}, "album-article-item", article, false)
                ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }